import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'

export class AcceptReviewService {
  /**
   * Report a review by id
   */
  public async reportReview(reviewId: number): Promise<void> {
    const scrubstrApiQueryService = new ScrubstrApiQueryService()

    await scrubstrApiQueryService.post({
      endpoint: `admin/accept-reported-review/${reviewId}`,
    })
  }
}
